import React from 'react';
import Chip, { ChipProps } from '@material-ui/core/Chip';
import withThemeProvider from '../util/withThemeProvider';

export type SolvChipProps = {
  backgroundColor: string;
  textColor: string;
} & ChipProps;

const SolvChip = ({ textColor, backgroundColor, ...rest }: SolvChipProps) => {
  return <Chip {...rest} style={{ color: textColor, backgroundColor }} />;
};

export default withThemeProvider(SolvChip);
